import React from 'react';
import { useState, useEffect } from 'react';
import "./UserMenu.css";
import SaveDocument from "assets/icons/save-documents.svg";
import CheckVerified from "assets/icons/check-verified.svg";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import { Help, ExitToApp, AccountCircle, Brightness2, ExpandMore, Person } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import Toggle from 'bootstrap-switch-button-react';
import useSelector from 'hooks/useSelector';
import { ExitCancelModel } from 'components/ui/InfoModal';
import { loadUserProfile, signoutRedirect } from 'shared/services/userService';
import {
    RecentlyActionedPath, FavouritesPath, FavouritesFilterTraditional, RecentlyActionedFilterTraditional, RecentlyActionedFilterCBTC, FavouritesFilterCBTC
} from 'components/ui/DocumentRules';
import { getUserExistingRulebookMode, getUserRulebookModeFromLocation } from '../../shared/store/applicationState';
import { RulebookNameToEnum, RulebookModeEnum } from '../../shared/enums/rulebook-mode-enum';

const USER_GUIDE_BASE_URL = "https://bhp.service-now.com/now/nav/ui/classic/params/target/%24viewer.do%3Fsysparm_stack%3Dno%26sysparm_sys_id=";
const CURRENT_USER_GUIDE_SYS_ID = "f3bc2eac4722aa5422b6413f016d43a5"; // This is SYS_ID for the PDF from servicenow

const ShowIcon = (props: { icon: any }) => {
    const Icon = props.icon;

    return (<Icon />)
}

export default () => {
    const [logoutMessage, setLogoutMessage] = useState("");
    const [mode, setMode] = useState('');
    const location = useLocation();

    const user = useSelector(state => state.user);
    const profile = useSelector(state => state.profile);

    const displayLogoutPrompt = () => {
        setLogoutMessage('Are you sure you want to log out?');
    }

    const closeLogoutPrompt = () => {
        setLogoutMessage('');
    }

    let userMode = getUserExistingRulebookMode();
    const updateToCurrentMode = () => {
        const userRulebookModeFromLocation = getUserRulebookModeFromLocation(location, userMode);
        userMode = userMode ?? userRulebookModeFromLocation;
        setMode(userMode);
    }

    useEffect(() => {
        updateToCurrentMode();
    }, [mode]);

    useEffect(() => {
        if (profile === undefined) {
            loadUserProfile();
        }
    }, []);

    return (
        <UncontrolledDropdown setActiveFromChild className="user-menu" onToggle={updateToCurrentMode}>
            <DropdownToggle tag='a' className='nav-link' caret>
                <Person className="user-icon" />
                {user &&
                    <span className="nav-bar-text user">
                        {profile?.firstname ?
                            <>Hi, {profile?.firstname}</>
                            :
                            <>Account</>
                        }
                    </span>
                }
                <ExpandMore />
            </DropdownToggle>
            <DropdownMenu right className="nav-bar-user-menu-dropdown">

                <DropdownItem header>My Account</DropdownItem>

                <DropdownItem tag={Link} to="/userprofile">
                    <span className="padded"><AccountCircle /></span><span>My profile details</span>
                </DropdownItem>

                {RulebookNameToEnum(userMode) === RulebookModeEnum.Traditional &&
                    <>
                        <DropdownItem tag={Link} to={FavouritesPath[0].url}>
                            <span className="padded"><ShowIcon icon={FavouritesFilterTraditional.icon} /></span><span>My favourite documents</span>
                    </DropdownItem>
                    <DropdownItem tag={Link} to={RecentlyActionedPath[0].url}>
                        <span className="padded"><ShowIcon icon={RecentlyActionedFilterTraditional.icon} /></span><span>My actioned documents</span>
                    </DropdownItem>
                    </>
                }

                {RulebookNameToEnum(userMode) === RulebookModeEnum.CBTC &&
                    <>
                        <DropdownItem tag={Link} to={FavouritesPath[1].url}>
                            <span className="padded"><ShowIcon icon={FavouritesFilterCBTC.icon} /></span><span>My favourite documents</span>
                        </DropdownItem>
                    <DropdownItem tag={Link} to={RecentlyActionedPath[1].url}>
                            <span className="padded"><ShowIcon icon={RecentlyActionedFilterCBTC.icon} /></span><span>My actioned documents</span>
                        </DropdownItem>
                    </>
                }

                <DropdownItem divider />

                <DropdownItem tag="a" href={`${USER_GUIDE_BASE_URL}${CURRENT_USER_GUIDE_SYS_ID}`} target="_blank">
                    <span className="padded"> <Help /> </span><span>User guide</span>
                </DropdownItem>

                <DropdownItem onClick={displayLogoutPrompt}>
                    <span className="padded"><ExitToApp /></span><span>Log out</span>
                </DropdownItem>

                <ExitCancelModel
                    isOpen={logoutMessage !== ''}
                    text={logoutMessage}
                    actionButtonText={'Log out'}
                    action={() => signoutRedirect()}
                    closeButtonText={'Cancel'}
                    closeAction={() => closeLogoutPrompt()}
                />
            </DropdownMenu>
        </UncontrolledDropdown>
    );
}





